import { DOServerKeys, GameType } from 'names/do-names';
import betModel from 'slotworks/model/bets/bet-model';
import Gameplay from 'slotworks/model/gameplay/gameplay-model';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import Record from 'slotworks/model/gameplay/records/record';
import BonusResult from 'slotworks/model/gameplay/records/results/bonus-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import slotDefinition from 'slotworks/model/slot-definition';
import GameInit from 'states/game-init';
import WildSticky from 'states/wild-sitcky';
import FreeSpinsRecord from './freespin-record';
import { OpenResponseSchema } from './open-response-schema';
import PickOneTreasureBonusRecord from './pickone-treasure-bonus-record';
import RecoveryBuilderBase from './recovery-builder-base';
import WildStickyRecorder from './wild-sticky-record';
import Components from 'slotworks/components/components';

class RecoveryRecordBuilder extends RecoveryBuilderBase {
    protected recoverBonuses(gameplay: Gameplay, data: any, openResponse: OpenResponseSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[]) {
        if (openResponse.OPEN.game === 'BONUS') {
            let pickRecord = new PickOneTreasureBonusRecord();
            pickRecord.is_complete = openResponse.OPEN.state.is_complete;
            pickRecord.triggered = openResponse.OPEN.state.triggering_game != DOServerKeys.TREASURE_BONUS && openResponse.OPEN.state.game === DOServerKeys.TREASURE_BONUS;
            pickRecord.pickedOptions = openResponse.OPEN.state.pickedOptions;
            pickRecord.rounds = openResponse.OPEN.state.rounds;
            pickRecord.total_win_cash = openResponse.OPEN.state.total_win_cash;
            const bonusResult = new BonusResult(openResponse.OPEN.game);
            dummySpinRecord.results.push(bonusResult, pickRecord);      
        }
        super.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const openResponse: OpenResponseSchema = data.data as OpenResponseSchema;
        let record = super.build(gameplay, data) as FreespinRecord[];
        if (record != null && record != undefined && record[0] != null && record[0] != undefined) {
            const freeSpinRecord = new FreeSpinsRecord();
            freeSpinRecord.gameName = openResponse.OPEN.state.game;
            freeSpinRecord.freespinsWon = openResponse.OPEN.state.total;
            freeSpinRecord.totalWinCash = openResponse.OPEN.state.total_win_cash;
            freeSpinRecord.triggering_game = openResponse.OPEN.state.triggering_game;
            freeSpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
            freeSpinRecord.total = openResponse.OPEN.state.total;
            freeSpinRecord.recover = false;
            record[0].results.push(freeSpinRecord);
        }

        if (openResponse.OPEN.game.indexOf('BASE') === -1) {
            const betState = openResponse.OPEN.bet_state;
            betModel.setSelectedLines(betState.lines);
            betModel.setBetPerLine(betState.bet_level);
            const coinLevel = slotDefinition.coinSizes[betState.coin_level - 1];
            betModel.setDefaults(slotDefinition.stakes[betState.bet_level - 1], betState.lines, coinLevel);
            Components.paytable.refreshBetOptions();
            Components.header.refreshOptions();
        }

        if (openResponse.OPEN.persisted_progress) {
            const wildStickyRecord = new WildStickyRecorder();
            wildStickyRecord.gameName = openResponse.OPEN.game;
            wildStickyRecord.persistedProgress = openResponse.OPEN.persisted_progress;
            GameInit.wildStickyRecorder = wildStickyRecord;
            if (openResponse.OPEN.game.indexOf('BASE') === -1 && openResponse.OPEN.game.indexOf('BONUS') === -1) {
                GameInit.gameType = GameType.freeSpin;
            }
            WildSticky.onRecoveryWildStickyBehaviour();

            if (record.length > 0) {
                record[0].results.push(wildStickyRecord);
            }
        }

        return record;
    }
}

export default new RecoveryRecordBuilder();



// WEBPACK FOOTER //
// ./src/integration/recovery-record-builder.ts